"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WriterCardFull = void 0;
const react_1 = __importStar(require("react"));
require("../index.scss");
const fields_validators_1 = require("@App/helpers/work-entities/fields-validators");
const string_escape_newlines_1 = require("@App/helpers/string-escape-newlines");
const contexts_1 = require("@App/contexts");
const validate_1 = require("@App/helpers/validate");
const clsx_1 = __importDefault(require("clsx"));
const WriterCardFull = (props) => {
    const { libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { data, addFunction, removeFunction } = props;
    const { firstName, lastName, ipiNumber, roleCode } = data;
    const roleOptions = libStore.writerRoles;
    const getRole = () => {
        if (!roleCode) {
            return '';
        }
        const writerRole = roleOptions.find((role) => +role.id === roleCode);
        if (writerRole && writerRole.label) {
            return writerRole.label;
        }
        return '';
    };
    const displayRole = getRole();
    return (react_1.default.createElement("div", { className: "writer-card" },
        react_1.default.createElement("div", { className: "head" },
            react_1.default.createElement("p", { className: "bold" },
                react_1.default.createElement("span", { className: (0, clsx_1.default)((0, fields_validators_1.writerFirstNameInvalidCheck)(firstName) && 'red-text bold') }, firstName ? (0, string_escape_newlines_1.stringEscapeNewlines)(firstName) : '___'),
                react_1.default.createElement("span", { className: (0, clsx_1.default)((0, fields_validators_1.writerLastNameInvalidCheck)(lastName) && 'red-text bold') }, lastName ? (0, string_escape_newlines_1.stringEscapeNewlines)(lastName) : '___')),
            react_1.default.createElement("div", { className: "controls" },
                addFunction ? react_1.default.createElement("span", { className: "small-2 medium" }, "Add") : null,
                removeFunction ? (react_1.default.createElement("span", { className: "small-2 medium", onClick: () => removeFunction(data) }, "Remove")) : null)),
        react_1.default.createElement("div", { className: "content" },
            react_1.default.createElement("p", { className: "small" },
                react_1.default.createElement("span", { className: (0, clsx_1.default)(!(0, validate_1.IPIValidator)(ipiNumber, false) && 'red-text bold') }, "IPI: "),
                react_1.default.createElement("strong", null, data.ipiNumber)),
            react_1.default.createElement("p", { className: "small" },
                react_1.default.createElement("span", { className: (0, clsx_1.default)((0, fields_validators_1.writerRoleInvalidCheck)(roleCode, roleOptions) && 'red-text bold') },
                    "Writer role:",
                    ' '),
                react_1.default.createElement("strong", null, !!displayRole && displayRole)))));
};
exports.WriterCardFull = WriterCardFull;
